import { useLegacyDraftCleanupPresenter } from "@/app/useLegacyDraftCleanupPresenter";

/** 旧クライアントが別タブから書き戻した本文を画面に依存せず破棄する。 */
export const LegacyDraftStorageCleanup: React.FunctionComponent = () => {
  useLegacyDraftCleanupPresenter();

  return null;
};
